<template>
  <b-img :src=src v-bind=this.props rounded="circle"/>
</template>

<script>
const md5 = require('md5')
export default {
  name: 'Gravatar',
  props: ['user', 'props'],
  computed: {
    src: function () {
      let hash = ''
      if (this.user) {
        hash = md5(this.user.email.trim().toLowerCase())
      }

      let def = '?d=mp'
      return 'https://www.gravatar.com/avatar/' + hash + def
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/user/Gravatar.vue